"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COOKIE_CONSENT_CLOSED = exports.COOKIE_CONSENT_ACCEPTED = void 0;
const COOKIE_CONSENT_ACCEPTED = {
  category: "cookies",
  action: "consent accepted",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.COOKIE_CONSENT_ACCEPTED = COOKIE_CONSENT_ACCEPTED;
const COOKIE_CONSENT_CLOSED = {
  category: "cookies",
  action: "consent closed",
  destinations: {
    datadog: true,
    bigQuery: true
  }
};
exports.COOKIE_CONSENT_CLOSED = COOKIE_CONSENT_CLOSED;